import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md page-enter">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-primary-c flex items-center justify-center text-white font-display text-lg">O</div>
          <span className="font-display text-2xl">Oresto</span>
        </Link>
        <div className="card-c">
          {!sent ? (
            <>
              <h1 className="font-display text-3xl">Mot de passe <span className="font-serif-italic text-primary-c">oublié ?</span></h1>
              <p className="text-text-secondary text-sm mt-1">Entrez votre email — nous vous envoyons un lien pour en choisir un nouveau.</p>
              <form onSubmit={onSubmit} className="mt-6 space-y-4">
                <div>
                  <label className="text-sm font-medium text-text-secondary block mb-2">Email</label>
                  <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-c" placeholder="vous@restaurant.ch" />
                </div>
                <button data-testid="forgot-submit-button" disabled={loading} className="btn-primary w-full">
                  {loading ? "Envoi…" : "Recevoir le lien"}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center">
              <CheckCircle2 className="w-12 h-12 text-primary-c mx-auto" />
              <h1 className="font-display text-2xl mt-4">Email envoyé</h1>
              <p className="text-text-secondary text-sm mt-2">
                Si un compte existe pour <strong className="text-[var(--text)]">{email}</strong>, vous recevrez un lien sous une minute.
              </p>
              <p className="text-xs text-text-secondary mt-4 flex items-center gap-1 justify-center">
                <Mail className="w-3.5 h-3.5" />Vérifiez aussi votre dossier spam.
              </p>
            </div>
          )}
          <p className="text-sm text-text-secondary mt-6 text-center">
            <Link to="/login" className="text-primary-c font-semibold" data-testid="forgot-back-link">← Retour à la connexion</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
